import { useMemo, useSyncExternalStore } from "react";

import tokenManager from "../utils/tokenManager";

// Stable references so useSyncExternalStore doesn't resubscribe each render.
const subscribe = (listener: () => void) => tokenManager.subscribe(listener);
const getSnapshot = () => tokenManager.getToken();

// Reactive read of the raw JWT. Re-renders when the token is set/removed, so a
// token established after the first render (e.g. the OIDC cookie promoted to
// localStorage on first load) is picked up instead of being frozen at its
// first-render value by React Compiler's memoisation.
export const useToken = () => useSyncExternalStore(subscribe, getSnapshot);

export const useDecodedToken = () => {
  const token = useToken();
  return useMemo(() => (token ? tokenManager.getDecodedToken() : undefined), [token]);
};

export const useUserData = () => {
  const token = useToken();
  return useMemo(() => (token ? tokenManager.getUserData() : undefined), [token]);
};

export const useIsImpersonationMode = () => {
  const decodedToken = useDecodedToken();
  return Boolean(decodedToken?.act);
};
